var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.DataComparison"),
        width: "1300px",
        "append-to-body": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", [
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c("cargo-ag-grid", {
              staticStyle: {
                "margin-top": "10px",
                height: "200px",
                width: "500px"
              },
              attrs: {
                "config-module": "26000526",
                "grid-options": _vm.cabinDataComparison.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.cabinDataComparison.rowData,
                "grid-params": _vm.cabinDataComparison.gridParams,
                "check-main-record": false,
                "deselect-main-record": false
              },
              on: {
                "update:gridParams": function($event) {
                  return _vm.$set(_vm.cabinDataComparison, "gridParams", $event)
                },
                "update:grid-params": function($event) {
                  return _vm.$set(_vm.cabinDataComparison, "gridParams", $event)
                },
                gridReady: function(params) {
                  return (_vm.cabinDataComparison.gridApi = params.api)
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              "word-wrap": "break-word",
              "white-space": "normal",
              "font-family": "sans-serif",
              margin: "15px 0 10px 30px"
            }
          },
          [
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 1 } }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Note")) + "：")
                  ])
                ]),
                _c("el-col", { attrs: { span: 15 } }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "CargoMsg.Cargo_TheRedFontFieldWillOverwriteTheSeaExportWithTheValueOfTheSpaceManagement"
                        )
                      )
                    )
                  ])
                ])
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c("el-col", {
                  staticStyle: { "min-height": "1px" },
                  attrs: { span: 1 }
                }),
                _c("el-col", { attrs: { span: 15 } }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "CargoMsg.Cargo_OriginalValueOfTheSeaExportAndWillNotBeOverwritten"
                        )
                      )
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }